module.exports = __webpack_public_path__ + "static/media/6.e57c6d5e.jpg";